import Link from "next/link";
import Image from "next/image";
import { DOCUMENT_URL } from "src/constants/constants";
import defaultImage from "image/image.svg";

interface Props {
  data: any;
}

const RecentArticles = ({ data }: Props) => {
  return (
    <>
      <p className="my-4 text-lg font-medium md:text-xl dark:text-dark-text-primary">
        Recent{" "}
      </p>
      <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 ">
        {data.map((eachArticle: any, eachInd: number) => (
          <div key={eachInd + 1 + ""}>
            <Link key={eachInd + 1 + ""} href={`/blog/${eachArticle.slug}`}>
              <div className="grid grid-cols-3 gap-4 sm:block">
                <Image
                  width={200}
                  height={250}
                  className={`w-full rounded`}
                  alt="article_imae"
                  src={
                    eachArticle.main_image.document_name
                      ? `${DOCUMENT_URL}${eachArticle.main_image.document_name}`
                      : defaultImage
                  }
                />
                <div className="col-span-2">
                  <p className="m-0 sm:mt-2 dark:text-dark-text-primary">
                    {eachArticle.title}
                  </p>{" "}
                </div>
              </div>
              {/* <p className="m-0 text-sm text-gray-500">
              {eachArticle.minute_read} min read
            </p> */}
              {/* <p className="m-0 text-sm text-gray-500">{eachArticle.summary}</p> */}
              {/* <hr /> */}
              {/* Continue Reading */}
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default RecentArticles;
